export const environment = {
  serverUrl: '/viteezy/api',
  apiToken: window["env"]["apiToken"]
};